import { FeatureData } from "views/components/Schedules/components/UpdateActivityPopup/styles";

const TabletContent = ({
    id, name, brand,
    model, serial, barcode
}) => {
    return (
        <FeatureData>
            <p>
                <b>{name} ({id})</b>
                <br/>
                {brand}/{model} serie: {serial}
                <br/>
                Código de barras: {barcode}
            </p>
        </FeatureData>
    );
}

export default TabletContent;